var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutorials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 34.5V22.5C48.5 12.5 44.5 8.5 34.5 8.5H22.5C12.5 8.5 8.5 12.5 8.5 22.5V34.5C8.5 44.5 12.5 48.5 22.5 48.5H34.5C44.5 48.5 48.5 44.5 48.5 34.5Z",
    stroke: "#727272",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54004 18.7188H47.46",
    stroke: "#727272",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.54 8.71875V18.4387",
    stroke: "#727272",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.46 8.71875V17.5387",
    stroke: "#727272",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 33.3963V30.9963C24 27.9163 26.18 26.6563 28.84 28.1963L30.92 29.3963L33 30.5963C35.66 32.1363 35.66 34.6563 33 36.1963L30.92 37.3963L28.84 38.5963C26.18 40.1363 24 38.8763 24 35.7963V33.3963V33.3963Z",
    stroke: "#727272",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorials);
export default __webpack_public_path__ + "static/media/Tutorials.d50b175174d4a4df7fb0d38d3ed7c983.svg";
export { ForwardRef as ReactComponent };